import { Colors } from "../../consts/Colors";
import FONTS from "../../consts/Fonts";
import { tags } from "../../consts/Tags";
import ButtonRounded from "../global/buttons/ButtonRounded";
import ScrollBar from "./ScrollBar";

export default class DebriefPanel extends Phaser.GameObjects.Container {
   constructor(scene) {
      super(scene, 0, 0, []);

      this.soundManager = scene.soundManager

      this.scene = scene;
      scene.add.existing(this);

      // Ajout du fond
      let background = this.scene.add.rectangle(0, 0, 1165, this.scene.height, Colors.Elmt.LightGrey).setOrigin(0);
      this.add(background);

      // Ajout de la bande
      let bande = this.scene.add.rectangle(0, 0, 80, background.height, Colors.Elmt.Blue).setOrigin(0);
      this.add(bande);

      let bande2 = this.scene.add.rectangle(80, 0, background.width - 80, 112, Colors.Elmt.LightGrey).setOrigin(0);
      this.add(bande2);

      this.scrollContainer = this.scene.add.container(0, 0);
      this.add(this.scrollContainer);

      // Gestion des positions
      this.sendToBack(this.scrollContainer);
      this.sendToBack(background);

      // Ajout du titre
      let debrief = this.scene.add.text(160, 66, "DEBRIEF", {
         fontSize: '14px',
         fontFamily: FONTS.InterRegular,
         color: Colors.Text.Blue
      }).setOrigin(0)
      this.add(debrief);

      let line = this.scene.add.rectangle(160, 112, 925, 1, Colors.Elmt.DarkGrey).setOrigin(0);
      this.add(line);

      // Ajout du texte qui peut etre scrollé
      const configTitre = {
         fontSize: '24px',
         fontFamily: FONTS.Inter24Bold,
         color: Colors.Text.Orange
      }
      const configText = {
         fontSize: '24px',
         fontFamily: FONTS.Inter24Medium,
         color: Colors.Text.Black
      }

      let titre
      let txt
      let text
      let texts
      let Y

      txt = "La circulation de citations apocryphes (faussement attribuées) est fréquente. Pour établir la véracité d’un propos, plusieurs étapes méthodologiques sont nécessaires."
      text = this.scene.add.text(160, 140, txt, configText).setOrigin(0).setWordWrapWidth(925);
      this.scrollContainer.add(text);
      Y = text.y + text.height + 24;

      this.MIN_SCROLL = 0

      // Part 1
      titre = this.scene.add.text(160, Y, "LA RECHERCHE DES TERMES EXACTS", configTitre).setOrigin(0).setWordWrapWidth(925);
      this.scrollContainer.add(titre);
      Y = titre.y + titre.height + 8;

      txt = "L’usage des guillemets dans un moteur de recherche (ex « phrase à vérifier ») permet de filtrer les résultats pour n’afficher que la séquence de mots précise."
      text = this.scene.add.text(160, Y, txt, configText).setOrigin(0).setWordWrapWidth(925);
      this.scrollContainer.add(text);
      Y = text.y + text.height + 24;

      texts = [
         "Si les occurrences sont rares ou limitées aux réseaux sociaux sans sources, la citation est suspecte.",
         "Une présence dans la presse de référence ou des publications académiques renforce sa crédibilité."
      ]
      Y = text.y + text.height + 24;
      texts.forEach((txt, index) => {
         let bullet = this.scene.add.circle(200, Y + 16, 6, Colors.Elmt.Orange);
         this.scrollContainer.add(bullet);

         let text = this.scene.add.rexTagText(240, Y, txt, {...configText, tags: tags, wordWrap: {width: 847}}).setOrigin(0);
         this.scrollContainer.add(text);

         Y += text.height + 24;
      })

      // Part 2 
      titre = this.scene.add.text(160, Y, "LE RECOURS AUX BASES DE DONNÉES SPÉCIALISÉES", configTitre).setOrigin(0).setWordWrapWidth(925);
      this.scrollContainer.add(titre);
      Y = titre.y + titre.height + 8;

      txt = "Deux outils permettent de distinguer l'authenticité d'une attribution légendaire :"
      text = this.scene.add.text(160, Y, txt, configText).setOrigin(0).setWordWrapWidth(925);
      this.scrollContainer.add(text);
      Y = text.y + text.height + 24;

      texts = [
         "<class=\"Inter24Bold_Orange\">Wikiquote : </class>Ce projet répertorie les citations en précisant leur source (ouvrage, discours). Il identifie clairement les phrases célèbres mais non sourcées dans des sections « Attribuées » ou « Fausses ».",
         "<class=\"Inter24Bold_Orange\">Quote Investigator : </class>Ce site retrace l'historique d'un propos pour remonter à sa première occurrence et comprendre comment une citation a pu être déformée ou glisser d'un auteur à un autre."
      ]
      texts.forEach((txt, index) => {
         let bullet = this.scene.add.circle(200, Y + 16, 6, Colors.Elmt.Orange);
         this.scrollContainer.add(bullet);

         let text = this.scene.add.rexTagText(240, Y, txt, {...configText, tags: tags, wordWrap: {width: 847}}).setOrigin(0);
         this.scrollContainer.add(text);

         Y += text.height + 24;
      })

      // Part 3
      titre = this.scene.add.text(160, Y, "LA QUÊTE DE LA SOURCE PRIMAIRE", configTitre).setOrigin(0).setWordWrapWidth(925);
      this.scrollContainer.add(titre);
      Y = titre.y + titre.height + 8;

      txt = "L'ultime vérification identifie le contexte d'origine. Une citation n'est prouvée que si l'on peut citer l'œuvre ou l'événement où elle a été formulée."
      text = this.scene.add.text(160, Y, txt, configText).setOrigin(0).setWordWrapWidth(925);
      this.scrollContainer.add(text);
      Y = text.y + text.height + 24;

      texts = [
         "<class=\"Inter24Bold_Orange\">Google Livre</class> facilite cette recherche dans des millions d'ouvrages numérisés.",
         "La vigilance est de mise face aux citations illustrées sur image ne mentionnant ni date, ni lieu, ni ouvrage de référence."
      ]
      texts.forEach((txt, index) => {
         let bullet = this.scene.add.circle(200, Y + 16, 6, Colors.Elmt.Orange);
         this.scrollContainer.add(bullet);

         let text = this.scene.add.rexTagText(240, Y, txt, {...configText, tags: tags, wordWrap: {width: 847}}).setOrigin(0);
         this.scrollContainer.add(text);

         Y += text.height + 24;
      })

      // Part 4
      titre = this.scene.add.text(160, Y, "LE GOOGLE DORKING", configTitre).setOrigin(0).setWordWrapWidth(925);
      this.scrollContainer.add(titre);
      Y = titre.y + titre.height + 8;

      txt = "Le \"Google Dorking\" utilise des opérateurs avancés pour filtrer les résultats et cibler des données précises, souvent invisibles via une recherche classique.\n\nOpérateurs clés :"
      text = this.scene.add.text(160, Y, txt, configText).setOrigin(0).setWordWrapWidth(925);
      this.scrollContainer.add(text);
      Y = text.y + text.height + 24;

      texts = [
         "<class=\"Inter24Bold_Orange\">site:lemonde.fr \"sujet\"</class> : Restreint la recherche exclusivement à ce média pour trouver une information exacte.",
         "<class=\"Inter24Bold_Orange\">inurl:lemonde.fr \"mot\"</class> : Cible les termes présents dans l'adresse URL des pages.",
         "<class=\"Inter24Bold_Orange\">filetype:pdf</class> : Isole des formats de fichiers spécifiques (rapports, tableurs, etc.).",
      ]
      texts.forEach((txt, index) => {
         let bullet = this.scene.add.circle(200, Y + 16, 6, Colors.Elmt.Orange);
         this.scrollContainer.add(bullet);

         let text = this.scene.add.rexTagText(240, Y, txt, {...configText, tags: tags, wordWrap: {width: 847}}).setOrigin(0);
         this.scrollContainer.add(text);

         Y += text.height + 24;
      })

      // Ajout du bouton de fermeture
      let closeBtn = new ButtonRounded(this.scene, background.width/2 + bande.width/2, Y + 48, {
         text: "Continuer",
         color: Colors.Elmt.Orange,
         textColor: Colors.Text.White,
         hoverColor: Colors.Elmt.Blue,
      })
      closeBtn.y += closeBtn.height/2;
      Y += closeBtn.height + 48;
      this.scrollContainer.add(closeBtn);

      closeBtn.setClickFunction(() => {
         this.animOut(() => {
            this.scene.closeDebrief()
         })      
      })

      this.setSize(background.width, background.height);

      this.MAX_SCROLL = Y + 80 - this.height;

      this.scene.input.on('wheel', (pointer, gameObjects, deltaX, deltaY, deltaZ)=>{
         console.log('wheel', deltaX, deltaY, deltaZ);
         let scrollValue = -deltaY
         this.scroll(scrollValue)
      })

      this.isDragging = false;
      this.startY = 0
      this.scene.input.on('pointerdown', (pointer) => {
         this.isDragging = true;
         this.startY = pointer.y;
      })
      this.scene.input.on('pointerup', (pointer) => {
         this.isDragging = false;
      })
      this.scene.input.on('pointermove', (pointer) => {
         if(this.isDragging){
               let deltaY = (pointer.y - this.startY);
               this.scroll(deltaY);
               this.startY = pointer.y;
         }
      })
      
      // Ajout scrollbar
      this.scrollbar = new ScrollBar(this.scene, background.width - 20, 10, background.height - 20)
      this.add(this.scrollbar)
   }

   
   scroll(deltaY){
        if(!this.scrollContainer || this.scrollContainer == undefined || this.scrollContainer == null) return;

        // Deplace les articles
        this.scrollContainer.y += deltaY * 0.25;

        console.log(this.scrollContainer.y, this.MIN_SCROLL, this.MAX_SCROLL)

        // Limite le scroll
        if(this.scrollContainer.y < -this.MAX_SCROLL) {
            this.scrollContainer.y = -this.MAX_SCROLL
        }
        if(this.scrollContainer.y >= this.MIN_SCROLL) {
            this.scrollContainer.y = this.MIN_SCROLL
        }

        let ratio = (-this.scrollContainer.y) / this.MAX_SCROLL;
        this.scrollbar.barreScroll.y = (this.scrollbar.height - this.scrollbar.barreScroll.height) * ratio;
    }

   animIn() {
      this.x = this.scene.width;

      this.soundManager.playOnce('PaperSlide4')
      this.scene.tweens.add({
         targets: this,
         x: this.scene.width - this.width,
         duration: 500,
         ease: 'Cubic.easeInOut'
       });

   }

   animOut(endFunc) {
      this.soundManager.playOnce('PaperSlide4')
      this.scene.tweens.add({
         targets: this,
         x: this.scene.width,
         duration: 500,
         ease: 'Cubic.easeInOut',
         onComplete: () => {
            // Animation complete
            if(endFunc) endFunc();
         }
       });
   }
}